(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.uikit = {}, global.React, global.PropTypes));
})(this, (function (exports, React, PropTypes) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var React__namespace = /*#__PURE__*/_interopNamespace(React);
  var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

  /** @typedef {number} ToastId */

  /**
   * @typedef {object} AddToastProps
   * @property {number} [props.timeout] - Time after which toast will be auto-removed.
   * @property {string} [props.message] - the toast's main message
   * @property {string} [props.title] - the toast's main message
   * @property {"debug"|"info"|"warn"|"error"|"task"} [props.severity] - message severity
   * @property {number} [props.timestamp] - time at which the log message occured
   * @property {React.ReactNode| React.ReactNode[]} [props.children] the Toast component childrens (React elements)
   */

  /**
   * adds a toast. it can accept any custom parameter that would get picked-up by a consummer later-on.
   * @typedef {(props:AddToastProps|string)=>ToastId} AddToast
   */

  /**
   * remove a toast immediately
   * @typedef {(id:ToastId)=>void} RemoveToast
   */

  /**
   * @typedef {object} ToastContextData
   * @property {AddToast} addToast
   * @property {RemoveToast} removeToast
   */

  /**@type {React.Context<ToastContextData>} */

  var ToastContext = /*#__PURE__*/React__default["default"].createContext(null);
  var ModalContext = /*#__PURE__*/React__default["default"].createContext(null);

  var context = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ToastContext: ToastContext,
    ModalContext: ModalContext
  });

  /**
   *  @returns {[Function, Function]}
   */

  function useModal() {
    var ctx = React.useContext(ModalContext);
    return [ctx.addModal, ctx.removeModal];
  }

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var arrayWithHoles = createCommonjsModule(function (module) {
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(arrayWithHoles);

  var iterableToArrayLimit = createCommonjsModule(function (module) {
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(iterableToArrayLimit);

  var arrayLikeToArray = createCommonjsModule(function (module) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(arrayLikeToArray);

  var unsupportedIterableToArray = createCommonjsModule(function (module) {
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(unsupportedIterableToArray);

  var nonIterableRest = createCommonjsModule(function (module) {
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(nonIterableRest);

  var slicedToArray = createCommonjsModule(function (module) {
  function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
  }

  module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _slicedToArray = unwrapExports(slicedToArray);

  /**
   * Wraps ToastContext
   * @returns {[import("../context").AddToast, import("../context").RemoveToast]} addToast, removeToast
   */

  function useToast() {
    var ctx = React.useContext(ToastContext);

    if (!ctx) {
      throw new Error("Missing ToastContext.Provider wrapper");
    }

    return [ctx.addToast, ctx.removeToast];
  }
  /**
   * Wraps ToastContext and auto-assign the "task" severity to addTask callback
   * @returns  {[import("../context").AddToast, import("../context").RemoveToast]} addTask, removeTask
   */

  function useTask() {
    var _useToast = useToast(),
        _useToast2 = _slicedToArray(_useToast, 2),
        addToast = _useToast2[0],
        removeToast = _useToast2[1];

    var addTask = function addTask(props) {
      if (typeof props === "string") props = {
        message: props,
        severity: "task"
      };else Object.assign(props, {
        severity: "task"
      });
      return addToast(props);
    };

    return [addTask, removeToast];
  }

  var defineProperty = createCommonjsModule(function (module) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _defineProperty = unwrapExports(defineProperty);

  var classCallCheck = createCommonjsModule(function (module) {
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _classCallCheck = unwrapExports(classCallCheck);

  var createClass = createCommonjsModule(function (module) {
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _createClass = unwrapExports(createClass);

  var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(setPrototypeOf);

  var inherits = createCommonjsModule(function (module) {
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }

  module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _inherits = unwrapExports(inherits);

  var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
  }

  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _typeof = unwrapExports(_typeof_1);

  var assertThisInitialized = createCommonjsModule(function (module) {
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _assertThisInitialized = unwrapExports(assertThisInitialized);

  var possibleConstructorReturn = createCommonjsModule(function (module) {
  var _typeof = _typeof_1["default"];



  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return assertThisInitialized(self);
  }

  module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

  var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _getPrototypeOf = unwrapExports(getPrototypeOf);

  var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
  }

  module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _extends$z = unwrapExports(_extends_1);

  var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(objectWithoutPropertiesLoose);

  var objectWithoutProperties = createCommonjsModule(function (module) {
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _objectWithoutProperties = unwrapExports(objectWithoutProperties);

  var BasePropTypes = {
    title: PropTypes__default["default"].node,
    name: PropTypes__default["default"].string.isRequired,
    value: PropTypes__default["default"].string,
    placeholder: PropTypes__default["default"].string,
    onChange: PropTypes__default["default"].func,
    emptyValue: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].bool]),
    allowEmpty: PropTypes__default["default"].bool
  };
  var BaseDefaultProps = {
    emptyValue: "Vide",
    allowEmpty: true
  };
  var ItemShape = {
    value: PropTypes__default["default"].string.isRequired,
    name: PropTypes__default["default"].string.isRequired,
    children: PropTypes__default["default"].node
  };
  var SelectorPropTypes = Object.assign({
    items: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape(ItemShape)), PropTypes__default["default"].arrayOf(PropTypes__default["default"].string)]).isRequired,
    minWidth: PropTypes__default["default"].number
  }, BasePropTypes);
  var FakeEvent = /*#__PURE__*/function () {
    function FakeEvent(name, value) {
      _classCallCheck(this, FakeEvent);

      this._target = {
        name: name,
        value: value
      };
    }

    _createClass(FakeEvent, [{
      key: "preventDefault",
      value: function preventDefault() {}
    }, {
      key: "persist",
      value: function persist() {}
    }, {
      key: "target",
      get: function get() {
        return Object.assign({}, this._target);
      }
    }]);

    return FakeEvent;
  }();

  var _excluded$6 = ["name", "value", "items", "onChange", "emptyValue", "allowEmpty"];
  /**
   * @typedef SelectorItem
   * @property {string} value each value should be unique
   * @property {string} [name] defaults to "value"
   */

  /**
   * Fully managed <select> component. User is responsible for state management and updating the "value" prop.
   * @param {Object} props
   * @param {string} props.name - the HTML input name
   * @param {string} props.value - selected value
   * @param {Array<SelectorItem|string>} props.items - list of items
   * @param {import("react").ChangeEventHandler<HTMLSelectElement>} props.onChange - change event handler (receive a raw event)
   * @param {string|null} [props.emptyValue] - Text for empty. Set to null to disable empty selection.
   * @param {boolean} [props.allowEmpty=true] - allow selection of the empty option
   */

  function Selector(_ref) {
    var name = _ref.name,
        value = _ref.value,
        items = _ref.items,
        onChange = _ref.onChange,
        _ref$emptyValue = _ref.emptyValue,
        emptyValue = _ref$emptyValue === void 0 ? "Vide" : _ref$emptyValue,
        _ref$allowEmpty = _ref.allowEmpty,
        allowEmpty = _ref$allowEmpty === void 0 ? true : _ref$allowEmpty,
        props = _objectWithoutProperties(_ref, _excluded$6);

    return /*#__PURE__*/React__default["default"].createElement("select", _extends$z({
      name: name,
      value: value,
      onChange: onChange
    }, props), typeof emptyValue === "string" && /*#__PURE__*/React__default["default"].createElement("option", {
      key: "empty",
      disabled: !allowEmpty,
      hidden: !allowEmpty,
      "aria-label": "empty-option",
      value: ""
    }, emptyValue), items.map(function (item) {
      var _ref2 = _typeof(item) == "object" ? item : {
        value: item
      },
          value = _ref2.value,
          _ref2$name = _ref2.name,
          name = _ref2$name === void 0 ? value : _ref2$name;

      return /*#__PURE__*/React__default["default"].createElement("option", {
        key: value,
        value: value
      }, name);
    }));
  }
  Selector.propTypes = SelectorPropTypes;
  Selector.defaultProps = BaseDefaultProps;

  function uid() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 5 : _ref$size,
        _ref$base = _ref.base,
        base = _ref$base === void 0 ? 36 : _ref$base;

    /* weak password generation function. Not to be used in situation where strong crypto is required */
    var password = "";

    while (password.length < size) {
      password += Math.random().toString(base).slice(2);
    }

    return password.slice(0, size);
  }

  function Checkbox(props) {
    var _useState = React.useState(uid()),
        _useState2 = _slicedToArray(_useState, 1),
        id = _useState2[0];

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "custom-control custom-checkbox"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      type: "checkbox",
      className: "custom-control-input",
      title: props.title,
      id: id,
      checked: props.checked,
      onChange: props.onChange
    }), /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: id,
      className: "custom-control-label"
    }, props.label));
  }
  Checkbox.propTypes = {
    title: PropTypes__default["default"].string,
    label: PropTypes__default["default"].string,
    onChange: PropTypes__default["default"].func,
    checked: PropTypes__default["default"].bool
  };

  function Switch(props) {
    var _useState = React.useState(uid()),
        _useState2 = _slicedToArray(_useState, 1),
        id = _useState2[0];

    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "switch-container"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      type: "checkbox",
      className: "switch",
      title: props.title,
      id: id,
      defaultChecked: props.checked,
      onChange: props.onChange
    }), /*#__PURE__*/React__default["default"].createElement("label", {
      htmlFor: id
    }));
  }
  Switch.propTypes = {
    title: PropTypes__default["default"].string,
    checked: PropTypes__default["default"].bool,
    onChange: PropTypes__default["default"].func
  };

  var _path$y;

  function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

  function SvgAlert(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$y({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, props), _path$y || (_path$y = /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      d: "M8.893 1.5c-.183-.31-.52-.5-.887-.5s-.703.19-.886.5L.138 13.499a.98.98 0 000 1.001c.193.31.53.501.886.501h13.964c.367 0 .704-.19.877-.5a1.03 1.03 0 00.01-1.002L8.893 1.5zm.133 11.497H6.987v-2.003h2.039v2.003zm0-3.004H6.987V5.987h2.039v4.006z"
    })));
  }

  var _path$x, _path2$u;

  function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

  function SvgArrowDown(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$x({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$x || (_path$x = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2$u || (_path2$u = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
    })));
  }

  var _path$w, _path2$t;

  function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

  function SvgArrowUp(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$w || (_path$w = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$t || (_path2$t = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
    })));
  }

  var _path$v, _path2$s;

  function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

  function SvgBack(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$v({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$v || (_path$v = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
    })), _path2$s || (_path2$s = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })));
  }

  var _path$u;

  function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

  function SvgBinary(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 12 16"
    }, props), _path$u || (_path$u = /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      d: "M4 12h1v1H2v-1h1v-2H2V9h2v3zm8-7.5V14c0 .55-.45 1-1 1H1c-.55 0-1-.45-1-1V2c0-.55.45-1 1-1h7.5L12 4.5zM11 5L8 2H1v12h10V5zM8 4H6v1h1v2H6v1h3V7H8V4zM2 4h3v4H2V4zm1 3h1V5H3v2zm3 2h3v4H6V9zm1 3h1v-2H7v2z"
    })));
  }

  var _path$t;

  function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

  function SvgBook(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$t({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, props), _path$t || (_path$t = /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      d: "M3 5h4v1H3V5zm0 3h4V7H3v1zm0 2h4V9H3v1zm11-5h-4v1h4V5zm0 2h-4v1h4V7zm0 2h-4v1h4V9zm2-6v9c0 .55-.45 1-1 1H9.5l-1 1-1-1H2c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h5.5l1 1 1-1H15c.55 0 1 .45 1 1zm-8 .5L7.5 3H2v9h6V3.5zm7-.5H9.5l-.5.5V12h6V3z"
    })));
  }

  var _path$s;

  function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

  function SvgBug(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, props), _path$s || (_path$s = /*#__PURE__*/React__namespace.createElement("path", {
      fillRule: "evenodd",
      d: "M11 10h3V9h-3V8l3.17-1.03-.34-.94L11 7V6c0-.55-.45-1-1-1V4c0-.48-.36-.88-.83-.97L10.2 2H12V1H9.8l-2 2h-.59L5.2 1H3v1h1.8l1.03 1.03C5.36 3.12 5 3.51 5 4v1c-.55 0-1 .45-1 1v1l-2.83-.97-.34.94L4 8v1H1v1h3v1L.83 12.03l.34.94L4 12v1c0 .55.45 1 1 1h1l1-1V6h1v7l1 1h1c.55 0 1-.45 1-1v-1l2.83.97.34-.94L11 11v-1zM9 5H6V4h3v1z"
    })));
  }

  var _path$r, _path2$r;

  function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

  function SvgBuild(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$r({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$r || (_path$r = /*#__PURE__*/React__namespace.createElement("path", {
      clipRule: "evenodd",
      fill: "none",
      d: "M0 0h24v24H0z"
    })), _path2$r || (_path2$r = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
    })));
  }

  var _path$q, _circle, _path2$q;

  function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

  function SvgCamera(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$q({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$q || (_path$q = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _circle || (_circle = /*#__PURE__*/React__namespace.createElement("circle", {
      cx: 12,
      cy: 12,
      r: 3.2
    })), _path2$q || (_path2$q = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    })));
  }

  var _path$p, _path2$p;

  function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

  function SvgCheck(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$p || (_path$p = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$p || (_path2$p = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })));
  }

  var _path$o, _path2$o;

  function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

  function SvgClose(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$o({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$o || (_path$o = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })), _path2$o || (_path2$o = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })));
  }

  var _path$n, _path2$n, _path3;

  function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

  function SvgDelete(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$n({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$n || (_path$n = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
    })), _path2$n || (_path2$n = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
    })), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })));
  }

  var _path$m, _path2$m;

  function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

  function SvgDrag(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$m || (_path$m = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2$m || (_path2$m = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    })));
  }

  var _path$l, _path2$l;

  function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

  function SvgEdit(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$l({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$l || (_path$l = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2$l || (_path2$l = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
    })));
  }

  var _path$k, _path2$k;

  function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

  function SvgFile(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$k({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$k || (_path$k = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2$k || (_path2$k = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
    })));
  }

  var _path$j, _path2$j;

  function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

  function SvgFilter(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$j({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$j || (_path$j = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    })), _path2$j || (_path2$j = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })));
  }

  var _path$i, _path2$i;

  function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

  function SvgForward(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$i || (_path$i = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
    })), _path2$i || (_path2$i = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })));
  }

  var _path$h, _path2$h;

  function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

  function SvgImage(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$h({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$h || (_path$h = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2$h || (_path2$h = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
    })));
  }

  var _path$g, _path2$g;

  function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

  function SvgInfo(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$g({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$g || (_path$g = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
    })), _path2$g || (_path2$g = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    })));
  }

  var _path$f, _path2$f;

  function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

  function SvgLibrary(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$f({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$f || (_path$f = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$f || (_path2$f = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
    })));
  }

  var _path$e, _path2$e;

  function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

  function SvgLink(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$e({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$e || (_path$e = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$e || (_path2$e = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    })));
  }

  var _path$d, _path2$d;

  function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

  function SvgMenu(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$d || (_path$d = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$d || (_path2$d = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    })));
  }

  var _path$c, _path2$c;

  function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

  function SvgNoteAdd(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$c({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$c || (_path$c = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$c || (_path2$c = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
    })));
  }

  var _path$b, _path2$b;

  function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

  function SvgPause(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$b({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$b || (_path$b = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    })), _path2$b || (_path2$b = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })));
  }

  var _path$a, _path2$a;

  function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

  function SvgPlay(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$a({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$a || (_path$a = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8 5v14l11-7z"
    })), _path2$a || (_path2$a = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })));
  }

  var _path$9, _path2$9;

  function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

  function SvgPlus(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$9({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$9 || (_path$9 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$9 || (_path2$9 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
    })));
  }

  var _path$8, _path2$8;

  function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

  function SvgPowerOff(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$8({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$8 || (_path$8 = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
    })), _path2$8 || (_path2$8 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18 14.49V9c0-1-1.01-2.01-2-2V3h-2v4h-4V3H8v2.48l9.51 9.5.49-.49zm-1.76 1.77L7.2 7.2l-.01.01L3.98 4 2.71 5.25l3.36 3.36C6.04 8.74 6 8.87 6 9v5.48L9.5 18v3h5v-3l.48-.48L19.45 22l1.26-1.28-4.47-4.46z"
    })));
  }

  var _path$7, _path2$7;

  function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

  function SvgRefresh(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$7({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$7 || (_path$7 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    })), _path2$7 || (_path2$7 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })));
  }

  var _path$6, _path2$6;

  function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

  function SvgRemove(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$6({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$6 || (_path$6 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$6 || (_path2$6 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
    })));
  }

  var _path$5, _path2$5;

  function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

  function SvgSave(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$5({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$5 || (_path$5 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$5 || (_path2$5 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
    })));
  }

  var _path$4, _path2$4;

  function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

  function SvgToggleOff(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$4({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$4 || (_path$4 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    })), _path2$4 || (_path2$4 = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })));
  }

  var _path$3, _path2$3;

  function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

  function SvgToggleOn(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$3({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$3 || (_path$3 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    })), _path2$3 || (_path2$3 = /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0z"
    })));
  }

  var _path$2, _path2$2;

  function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

  function SvgUpload(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$2({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$2 || (_path$2 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    })), _path2$2 || (_path2$2 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
    })));
  }

  var _path$1, _path2$1;

  function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

  function SvgVideo(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends$1({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path$1 || (_path$1 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2$1 || (_path2$1 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z"
    })));
  }

  var _path, _path2;

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  function SvgView(props) {
    return /*#__PURE__*/React__namespace.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    })), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 6a9.77 9.77 0 018.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0112 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
    })));
  }

  var _excluded$5 = ["icon", "className", "height", "size", "verticalAlign", "width"];

  function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  var sizeMap$1 = {
    small: 16,
    medium: 32,
    large: 64,
    text: "1em",
    responsive: "1rem",
    auto: undefined
  };
  var alignMap = {
    top: 'text-top',
    middle: 'middle'
  };
  /**
   * 
   * @param {object} props
   * @param {SvgIcon} props.icon
   * @param {string} props.className
   * @param {number} [props.height]
   * @param {number} [props.width]
   * @param {number|keyof typeof sizeMap} [props.size]
   * @param {'middle'|'text-bottom'|'text-top'|'top'|'unset'} [props.verticalAlign]
   */

  function Icon(_ref) {
    var SvgIcon = _ref.icon,
        className = _ref.className,
        height = _ref.height,
        size = _ref.size,
        verticalAlign = _ref.verticalAlign,
        width = _ref.width,
        otherAttrs = _objectWithoutProperties(_ref, _excluded$5);

    if (typeof SvgIcon === "undefined") {
      console.error("Invalid icon provided (" + SvgIcon + "). Using a default placeholder");
      SvgIcon = SvgBinary;
    }

    var attrs = _objectSpread$2({
      className: className,
      role: 'img',
      style: {
        display: 'inline-block',
        fill: 'currentColor',
        userSelect: 'none',
        verticalAlign: alignMap[verticalAlign] || verticalAlign,
        width: width || sizeMap$1[size] || size,
        height: height || sizeMap$1[size] || size
      }
    }, otherAttrs);

    return /*#__PURE__*/React__default["default"].createElement(SvgIcon, attrs);
  }
  Icon.defaultProps = {
    size: "responsive",
    verticalAlign: 'text-bottom',
    className: 'icon'
  };
  Icon.propTypes = {
    height: PropTypes__default["default"].number,
    width: PropTypes__default["default"].number,
    icon: PropTypes__default["default"].func,
    size: PropTypes__default["default"].oneOfType([PropTypes__default["default"].number, PropTypes__default["default"].oneOf(Object.keys(sizeMap$1))]),
    verticalAlign: PropTypes__default["default"].oneOf(['middle', 'text-bottom', 'text-top', 'top', 'unset']),
    className: PropTypes__default["default"].string
  };

  var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': Icon,
    Alert: SvgAlert,
    ArrowDown: SvgArrowDown,
    ArrowUp: SvgArrowUp,
    Back: SvgBack,
    Binary: SvgBinary,
    Book: SvgBook,
    Bug: SvgBug,
    Build: SvgBuild,
    Camera: SvgCamera,
    Check: SvgCheck,
    Close: SvgClose,
    Delete: SvgDelete,
    Drag: SvgDrag,
    Edit: SvgEdit,
    File: SvgFile,
    Filter: SvgFilter,
    Forward: SvgForward,
    Image: SvgImage,
    Info: SvgInfo,
    Library: SvgLibrary,
    Link: SvgLink,
    Menu: SvgMenu,
    NoteAdd: SvgNoteAdd,
    Pause: SvgPause,
    Play: SvgPlay,
    Plus: SvgPlus,
    PowerOff: SvgPowerOff,
    Refresh: SvgRefresh,
    Remove: SvgRemove,
    Save: SvgSave,
    ToggleOff: SvgToggleOff,
    ToggleOn: SvgToggleOn,
    Upload: SvgUpload,
    Video: SvgVideo,
    View: SvgView
  });

  /**
   * A flat list of entries. Can be shown as simple list of items or key-values Map
   * A new item may be any string. How it would be added to the list is up to the implementor
   * @see FlatMap for a straightforward implementation of key => value strings record.
   */

  function FlatList(_ref) {
    var items = _ref.items,
        name = _ref.name,
        onRemove = _ref.onRemove,
        onAdd = _ref.onAdd,
        _ref$newItem = _ref.newItem,
        NewItem = _ref$newItem === void 0 ? NewListItem : _ref$newItem,
        _ref$item = _ref.item,
        Item = _ref$item === void 0 ? ListItem : _ref$item;

    if (typeof items[0] === "string") {
      items = items.map(function (i) {
        return {
          name: i
        };
      });
    }

    return /*#__PURE__*/React__default["default"].createElement("ul", {
      id: name,
      className: "list-group list-group-flush"
    }, items.map(function (i) {
      return /*#__PURE__*/React__default["default"].createElement(Item, _extends$z({
        key: i.name,
        onRemove: onRemove
      }, i));
    }), typeof onAdd === "function" && /*#__PURE__*/React__default["default"].createElement(NewItem, {
      key: items.length,
      onAdd: onAdd,
      name: name
    }));
  }
  FlatList.propTypes = {
    items: PropTypes__default["default"].arrayOf(PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].shape({
      name: PropTypes__default["default"].string.isRequired
    })])).isRequired,
    name: PropTypes__default["default"].string,
    onRemove: PropTypes__default["default"].func,
    onAdd: PropTypes__default["default"].func,
    newItem: PropTypes__default["default"].func,
    item: PropTypes__default["default"].func
  };
  function NewListItem(_ref2) {
    var onAdd = _ref2.onAdd,
        name = _ref2.name;

    var _useState = React.useState(""),
        _useState2 = _slicedToArray(_useState, 2),
        newName = _useState2[0],
        setNewName = _useState2[1];

    return /*#__PURE__*/React__default["default"].createElement("li", {
      className: "list-group-item d-flex justify-content-between align-items-center"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      className: "form-control",
      name: "new-".concat(name),
      value: newName,
      type: "text",
      onChange: function onChange(e) {
        return setNewName(e.target.value);
      }
    }), /*#__PURE__*/React__default["default"].createElement("button", {
      role: "button",
      onClick: function onClick() {
        onAdd(newName);
        setNewName("");
      },
      "data-testid": "flatlist-add",
      className: "btn badge badge-success badge-pill"
    }, /*#__PURE__*/React__default["default"].createElement(Icon, {
      icon: SvgPlus
    })));
  }
  NewListItem.propTypes = {
    onAdd: PropTypes__default["default"].func.isRequired,
    name: PropTypes__default["default"].string
  };
  function ListItem(_ref3) {
    var onRemove = _ref3.onRemove,
        name = _ref3.name,
        children = _ref3.children;
    return /*#__PURE__*/React__default["default"].createElement("li", {
      id: "ListItem-".concat(name),
      className: "list-group-item d-flex justify-content-between align-items-center"
    }, children || name, typeof onRemove === "function" && /*#__PURE__*/React__default["default"].createElement("button", {
      "aria-controls": "ListItem-".concat(name),
      "aria-label": "remove-".concat(name),
      onClick: function onClick() {
        return onRemove(name);
      },
      className: "badge badge-danger badge-pill btn"
    }, /*#__PURE__*/React__default["default"].createElement(Icon, {
      icon: SvgClose
    })));
  }
  ListItem.propTypes = {
    onRemove: PropTypes__default["default"].func,
    name: PropTypes__default["default"].string.isRequired,
    children: PropTypes__default["default"].node
  };
  function NewMapItem(_ref4) {
    var onAdd = _ref4.onAdd,
        name = _ref4.name;

    var _useState3 = React.useState(""),
        _useState4 = _slicedToArray(_useState3, 2),
        newName = _useState4[0],
        setNewName = _useState4[1];

    var _useState5 = React.useState(""),
        _useState6 = _slicedToArray(_useState5, 2),
        newValue = _useState6[0],
        setNewValue = _useState6[1];

    return /*#__PURE__*/React__default["default"].createElement("li", {
      className: "new-map-item list-group-item d-flex justify-content-stretch align-items-center"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group flex-grow-1"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group-prepend"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      className: "form-control new-map-item--name",
      name: "new-".concat(name),
      value: newName,
      placeholder: "name",
      type: "text",
      onChange: function onChange(e) {
        return setNewName(e.target.value);
      }
    })), /*#__PURE__*/React__default["default"].createElement("input", {
      className: "form-control new-map-item--value",
      name: "new-".concat(name),
      value: newValue,
      placeholder: "value",
      type: "text",
      onChange: function onChange(e) {
        return setNewValue(e.target.value);
      }
    })), /*#__PURE__*/React__default["default"].createElement("button", {
      onClick: function onClick() {
        onAdd(newName, newValue);
        setNewName("");
      },
      "data-testid": "flatlist-add",
      className: "badge badge-success badge-pill btn"
    }, /*#__PURE__*/React__default["default"].createElement(Icon, {
      icon: SvgPlus
    })));
  }
  NewMapItem.propTypes = {
    onAdd: PropTypes__default["default"].func.isRequired,
    name: PropTypes__default["default"].string
  };
  function MapItem(_ref5) {
    var onRemove = _ref5.onRemove,
        name = _ref5.name,
        value = _ref5.value;
    return /*#__PURE__*/React__default["default"].createElement(ListItem, {
      onRemove: onRemove,
      name: name
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group flex-grow-1"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group-prepend"
    }, /*#__PURE__*/React__default["default"].createElement("input", {
      className: "form-control map-item--name",
      name: "".concat(name),
      value: name,
      placeholder: "name",
      type: "text",
      readOnly: true
    })), /*#__PURE__*/React__default["default"].createElement("input", {
      className: "form-control map-item--value",
      name: "".concat(name),
      value: value,
      type: "text",
      readOnly: true
    })));
  }
  MapItem.propTypes = {
    onRemove: PropTypes__default["default"].func,
    name: PropTypes__default["default"].string.isRequired,
    value: PropTypes__default["default"].string.isRequired,
    children: PropTypes__default["default"].node
  };
  /**
   * flat map of  {[key:string]: string}
   * 
   * @see FlatList for a more flexible container
   */

  function FlatMap(props) {
    return /*#__PURE__*/React__default["default"].createElement(FlatList, _extends$z({
      item: MapItem,
      newItem: NewMapItem
    }, props));
  }
  FlatMap.propTypes = {
    items: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
      name: PropTypes__default["default"].string.isRequired,
      value: PropTypes__default["default"].string.isRequired
    })).isRequired,
    name: PropTypes__default["default"].string,
    onRemove: PropTypes__default["default"].func,
    onAdd: PropTypes__default["default"].func,
    newItem: PropTypes__default["default"].func,
    item: PropTypes__default["default"].func
  };

  var _excluded$4 = ["onChange", "value"];
  function withState(WrappedComponent) {
    function TextInput(_ref) {
      var onChange = _ref.onChange,
          originalValue = _ref.value,
          props = _objectWithoutProperties(_ref, _excluded$4);

      var _useState = React.useState(originalValue),
          _useState2 = _slicedToArray(_useState, 2),
          value = _useState2[0],
          setValue = _useState2[1];

      if (["undefined", "function"].indexOf(_typeof(onChange)) === -1) console.warn("onChange handler should be a function. Found ".concat(_typeof(onChange)));
      var onChildrenChange = React.useCallback(function (e) {
        setValue(e.target.value);
        if (typeof onChange === "function") onChange(e);
      }, [onChange, setValue]);
      return /*#__PURE__*/React__default["default"].createElement(WrappedComponent, _extends$z({
        onChange: onChildrenChange,
        value: value
      }, props));
    }

    TextInput.propTypes = {
      onChange: PropTypes__default["default"].func,
      value: PropTypes__default["default"].string
    };
    return TextInput;
  }

  var _excluded$3 = ["id", "content", "message"];
  var logLevels = ["debug", "info", "warn", "error", "task"];
  var icons = [SvgBook, SvgInfo, SvgAlert, SvgBug];
  var titleClasses = ["text-muted", "text-dark", "text-warning", "text-danger"];
  function ToastIcon(_ref) {
    var severity = _ref.severity;
    var idx = logLevels.indexOf(severity);
    if (idx === -1) idx = 1;

    if (icons.length < idx + 1) {
      console.warn("No available icon for log level : ", severity);
      idx = 1;
    }

    return /*#__PURE__*/React__default["default"].createElement(Icon, {
      "data-severity": severity,
      "aria-label": "toast",
      icon: icons[idx]
    });
  }
  ToastIcon.propTypes = {
    severity: PropTypes__default["default"].oneOf(logLevels)
  };
  /**
   * Toast display component
   * @param {*} param0 
   */

  function Toast(_ref2) {
    var id = _ref2.id,
        title = _ref2.title,
        severity = _ref2.severity,
        timestamp = _ref2.timestamp,
        children = _ref2.children,
        onDismiss = _ref2.onDismiss;
    var severityIndex = logLevels.indexOf(severity);
    if (severityIndex === -1) severityIndex = 1;
    severity = logLevels[severityIndex]; //Filter potential bad severity levels

    title = title || severity;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      id: id,
      className: "toast show",
      role: "alert",
      "aria-live": "assertive",
      "aria-atomic": "true"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "toast-header ".concat(titleClasses[severityIndex])
    }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(ToastIcon, {
      severity: severity
    }), /*#__PURE__*/React__default["default"].createElement("strong", {
      className: "mr-auto ml-1"
    }, title)), /*#__PURE__*/React__default["default"].createElement("small", null, timestamp), onDismiss && /*#__PURE__*/React__default["default"].createElement("button", {
      type: "button",
      className: "btn border-0 ml-2 mb-1 close",
      "data-dismiss": "toast",
      "aria-label": "Close",
      onClick: onDismiss
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "toast-body"
    }, children));
  }
  Toast.propTypes = {
    id: PropTypes__default["default"].number.isRequired,
    title: PropTypes__default["default"].string,
    severity: PropTypes__default["default"].oneOf(logLevels),
    timestamp: PropTypes__default["default"].instanceOf(Date),
    onDismiss: PropTypes__default["default"].func,
    children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].element, PropTypes__default["default"].arrayOf(PropTypes__default["default"].element)])
  };
  function ToastContainer(_ref3) {
    var _ref3$toasts = _ref3.toasts,
        toasts = _ref3$toasts === void 0 ? [] : _ref3$toasts,
        _ref3$capacity = _ref3.capacity,
        capacity = _ref3$capacity === void 0 ? -1 : _ref3$capacity;
    var truncate = 0 < capacity && capacity < toasts.length;
    var displayed_toasts = truncate ? toasts.slice(0, capacity - 1) : toasts;
    var hidden_toasts = truncate ? toasts.slice(capacity).length + 1 : 0;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      "data-testid": "toast-container",
      className: "toast-container"
    }, displayed_toasts.map(function (_ref4) {
      var id = _ref4.id,
          content = _ref4.content,
          message = _ref4.message,
          item = _objectWithoutProperties(_ref4, _excluded$3);

      return /*#__PURE__*/React__default["default"].createElement(Toast, _extends$z({
        key: id,
        id: id
      }, item), content || message);
    }), 0 < hidden_toasts && /*#__PURE__*/React__default["default"].createElement(Toast, {
      severity: "warn",
      id: -1,
      title: "Trop de logs"
    }, "+ ".concat(hidden_toasts, " messages cach\xE9s")));
  }
  ToastContainer.propTypes = {
    toasts: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    capacity: PropTypes__default["default"].number
  }; //Though their name is different, tasks are toasts with a severity of "task".

  function TaskContainer(_ref5) {
    var _ref5$tasks = _ref5.tasks,
        tasks = _ref5$tasks === void 0 ? [] : _ref5$tasks,
        title = _ref5.title;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      "data-testid": "task-container",
      className: "task-container"
    }, tasks.length !== 0 && /*#__PURE__*/React__default["default"].createElement("div", {
      role: "status",
      className: "tasks-pending",
      title: title
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "break dot"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "break dot"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "break dot"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "break dot"
    })));
  }
  TaskContainer.propTypes = {
    tasks: PropTypes__default["default"].arrayOf(PropTypes__default["default"].object),
    title: PropTypes__default["default"].string
  };

  var _excluded$2 = ["children"];
  function Tooltip(_ref) {
    var _ref$id = _ref.id,
        id = _ref$id === void 0 ? uid() : _ref$id,
        icon = _ref.icon,
        className = _ref.className,
        children = _ref.children;
    return /*#__PURE__*/React__default["default"].createElement("span", {
      "aria-describedby": id,
      className: "tooltip-container"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "tooltip-icon".concat(className ? " " + className : "")
    }, icon), /*#__PURE__*/React__default["default"].createElement("div", {
      id: id,
      role: "tooltip",
      className: "tooltip-hover"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "tooltip-arrow border-primary"
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "tooltip-label bg-primary text-white rounded shadow-sm"
    }, children)));
  }
  Tooltip.propTypes = {
    id: PropTypes__default["default"].string,
    icon: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].element]).isRequired,
    color: PropTypes__default["default"].string,
    className: PropTypes__default["default"].string,
    children: PropTypes__default["default"].node
  };
  /* tooltip with a pre-built Info icon */

  /* eslint-disable-next-line react/prop-types*/

  function Infotip(_ref2) {
    var children = _ref2.children,
        props = _objectWithoutProperties(_ref2, _excluded$2);

    return /*#__PURE__*/React__default["default"].createElement(Tooltip, _extends$z({
      icon: /*#__PURE__*/React__default["default"].createElement(Icon, {
        icon: SvgInfo
      })
    }, props), children);
  }

  var pageStyle = {
    height: "calc(100vh - 170px)",
    // footer + navbar heights
    alignItems: "center"
  };
  var sizeMap = {
    "small": 24,
    "medium": 32,
    "large": 64
  };
  function Loader(_ref) {
    var page = _ref.page,
        id = _ref.id,
        inline = _ref.inline,
        title = _ref.title,
        children = _ref.children,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? "medium" : _ref$size,
        _ref$active = _ref.active,
        active = _ref$active === void 0 ? true : _ref$active;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      id: id,
      "data-testid": "loader-container",
      className: "position-relative d-flex w-100 justify-content-center pt-4 align-items-center",
      style: Object.assign({
        opacity: active ? "1" : "0"
      }, page ? pageStyle : {})
    }, children && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "spinner-icon position-absolute"
    }, children), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "spinner ".concat(inline ? "spinner-grow spinner-grow-sm" : "spinner-border"),
      style: {
        width: sizeMap[size],
        height: sizeMap[size]
      },
      role: "status",
      "aria-label": "loading",
      title: title
    }));
  }
  Loader.propTypes = {
    page: PropTypes__default["default"].bool,
    id: PropTypes__default["default"].string,
    inline: PropTypes__default["default"].bool,
    children: PropTypes__default["default"].node,
    title: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOf(["small", "medium", "large"]),
    active: PropTypes__default["default"].bool
  };

  function ErrorMessage(_ref) {
    var error = _ref.error,
        message = _ref.message,
        title = _ref.title,
        stack = _ref.stack;

    if (error) {
      message = message || error.message;
      title = title || error.name;
      stack = stack || error.stack;
    }

    if (!message) {
      console.warn("ErrorMessage is supposed to be given at least a non-empty message prop. Got : " + _typeof(message));
      message = "Unspecified error";
    }

    return /*#__PURE__*/React__default["default"].createElement("div", {
      role: "alert",
      className: "jumbotron"
    }, /*#__PURE__*/React__default["default"].createElement("h1", {
      className: "display-4"
    }, title || "Error", " :"), /*#__PURE__*/React__default["default"].createElement("pre", {
      "data-test": "error-message",
      style: {
        whiteSpace: "pre-wrap",
        overflow: "hidden"
      },
      className: "lead"
    }, message), stack && /*#__PURE__*/React__default["default"].createElement("code", {
      role: "complementary"
    }, /*#__PURE__*/React__default["default"].createElement("pre", null, stack)));
  }
  ErrorMessage.propTypes = {
    message: PropTypes__default["default"].string,
    title: PropTypes__default["default"].string,
    stack: PropTypes__default["default"].string,
    error: PropTypes__default["default"].object
  };

  function Modal(_ref) {
    var title = _ref.title,
        actions = _ref.actions,
        onDismiss = _ref.onDismiss,
        children = _ref.children,
        _ref$backgroundColor = _ref.backgroundColor,
        backgroundColor = _ref$backgroundColor === void 0 ? "rgba(0,0,0,0.8)" : _ref$backgroundColor,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? "Modal" : _ref$name;
    var id = "modal_".concat(uid({
      size: 5
    }));
    return /*#__PURE__*/React__default["default"].createElement("div", {
      id: id,
      "data-name": name,
      className: "modal fade show",
      tabIndex: -1,
      role: "dialog",
      style: {
        display: "block",
        backgroundColor: backgroundColor
      },
      onClick: function onClick(e) {
        // @ts-ignore
        if (e.target.id === id) onDismiss();
      }
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "modal-dialog",
      role: "document"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "modal-content"
    }, title && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "modal-header"
    }, /*#__PURE__*/React__default["default"].createElement("h5", {
      className: "modal-title"
    }, title), /*#__PURE__*/React__default["default"].createElement("button", {
      onClick: onDismiss,
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "modal-body"
    }, children), actions && /*#__PURE__*/React__default["default"].createElement("div", {
      className: "modal-footer",
      role: "menu"
    }, actions))));
  }
  Modal.propTypes = {
    name: PropTypes__default["default"].string,
    title: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].element]).isRequired,
    onDismiss: PropTypes__default["default"].func.isRequired,
    background: PropTypes__default["default"].string,
    children: PropTypes__default["default"].node,
    actions: PropTypes__default["default"].node,
    backgroundColor: PropTypes__default["default"].string
  };

  var _excluded$1 = ["name", "value", "onConfirm"];

  function StackModal(_ref) {
    var title = _ref.title,
        children = _ref.children,
        onDismiss = _ref.onDismiss,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? "StackModal" : _ref$name;
    return /*#__PURE__*/React__default["default"].createElement(Modal, {
      title: title,
      onDismiss: onDismiss,
      name: name
    }, children);
  }
  StackModal.propTypes = Modal.propTypes;
  function ConfirmModal(_ref2) {
    var title = _ref2.title,
        onDismiss = _ref2.onDismiss,
        onConfirm = _ref2.onConfirm,
        children = _ref2.children,
        _ref2$text = _ref2.text,
        text = _ref2$text === void 0 ? {
      save: "Save changes",
      close: "Close"
    } : _ref2$text,
        _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? "ConfirmModal" : _ref2$name;
    var actions = [];

    if (typeof onConfirm === "function") {
      actions.push( /*#__PURE__*/React__default["default"].createElement("button", {
        onClick: onConfirm,
        type: "button",
        key: "save",
        "data-confirm": "modal",
        "aria-label": "Confirm",
        className: "btn btn-primary"
      }, text.save));
    }

    if (typeof onDismiss === "function") {
      actions.push( /*#__PURE__*/React__default["default"].createElement("button", {
        onClick: onDismiss,
        type: "button",
        key: "cancel",
        "data-dismiss": "modal",
        "aria-label": "Dismiss",
        className: "btn btn-secondary"
      }, text.close));
    }

    return /*#__PURE__*/React__default["default"].createElement(Modal, {
      name: name,
      title: title,
      onDismiss: onDismiss,
      actions: actions
    }, children);
  }
  ConfirmModal.propTypes = Object.assign({}, Modal.propTypes, {
    onConfirm: PropTypes__default["default"].func.isRequired
  });
  function TextInputModal(_ref3) {
    var name = _ref3.name,
        _ref3$value = _ref3.value,
        initialValue = _ref3$value === void 0 ? "" : _ref3$value,
        onConfirm = _ref3.onConfirm,
        props = _objectWithoutProperties(_ref3, _excluded$1);

    var _useState = React.useState(initialValue),
        _useState2 = _slicedToArray(_useState, 2),
        value = _useState2[0],
        setValue = _useState2[1];

    var handleConfirm = typeof onConfirm === "function" ? function () {
      return onConfirm(value);
    } : undefined;
    return /*#__PURE__*/React__default["default"].createElement(ConfirmModal, _extends$z({
      name: "TextInputModal"
    }, props, {
      onConfirm: handleConfirm
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group mb-3"
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "input-group-prepend"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: "input-group-text",
      style: {
        minWidth: 100,
        textAlign: "right"
      },
      id: name
    }, name)), /*#__PURE__*/React__default["default"].createElement("input", {
      disabled: typeof onConfirm !== "function",
      "data-test": "form-title-content",
      type: "text",
      name: name,
      className: "col-sm-8 col-md-9 col-lg-10 form-control",
      "aria-label": "modal-input",
      "aria-describedby": name,
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      }
    })));
  }
  TextInputModal.propTypes = ConfirmModal.propTypes;

  function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  var InnerErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inherits(InnerErrorBoundary, _React$Component);

    var _super = _createSuper$2(InnerErrorBoundary);

    function InnerErrorBoundary(props) {
      _classCallCheck(this, InnerErrorBoundary);

      return _super.call(this, props);
    }

    _createClass(InnerErrorBoundary, [{
      key: "shouldComponentUpdate",
      value: function shouldComponentUpdate(nextProps) {
        var _this = this;

        return !["children", "hasError", "error", "errorInfo"].every(function (key) {
          return nextProps[key] === _this.props[key];
        });
      }
    }, {
      key: "render",
      value: function render() {
        if (this.props.hasError) {
          // Error path
          return /*#__PURE__*/React__default["default"].createElement(ErrorMessage, {
            title: "Something went wrong",
            message: this.props.error.toString(),
            stack: this.props.errorInfo.componentStack
          });
        } // Normally, just render children


        return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, this.props.children);
      }
    }]);

    return InnerErrorBoundary;
  }(React__default["default"].Component);

  InnerErrorBoundary.propTypes = {
    hasError: PropTypes__default["default"].bool,
    error: PropTypes__default["default"].object,
    errorInfo: PropTypes__default["default"].shape({
      componentStack: PropTypes__default["default"].string
    }),
    children: PropTypes__default["default"].node
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component2) {
    _inherits(ErrorBoundary, _React$Component2);

    var _super2 = _createSuper$2(ErrorBoundary);

    function ErrorBoundary(props) {
      var _this2;

      _classCallCheck(this, ErrorBoundary);

      _this2 = _super2.call(this, props);
      _this2.state = {
        hasError: false,
        toasts: [],
        tasks: []
      };
      return _this2;
    }

    _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
          hasError: true,
          error: error,
          errorInfo: errorInfo,
          weakKey: this.props.weakKey
        }); // You can also log error messages to an error reporting service here

        if (typeof this.props.reporter === "function") this.props.reporter(error, errorInfo);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default["default"].createElement(InnerErrorBoundary, {
          error: this.state.error,
          errorInfo: this.state.errorInfo,
          hasError: this.state.hasError
        }, this.props.children);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(props, state) {
        var errorIsActive = state.hasError && state.weakKey === props.weakKey;
        return {
          hasError: errorIsActive
        };
      }
    }]);

    return ErrorBoundary;
  }(React__default["default"].Component);

  _defineProperty(ErrorBoundary, "propTypes", {
    reporter: PropTypes__default["default"].func,
    children: PropTypes__default["default"].node,
    weakKey: PropTypes__default["default"].any
  });

  var arrayWithoutHoles = createCommonjsModule(function (module) {
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }

  module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(arrayWithoutHoles);

  var iterableToArray = createCommonjsModule(function (module) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(iterableToArray);

  var nonIterableSpread = createCommonjsModule(function (module) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  unwrapExports(nonIterableSpread);

  var toConsumableArray = createCommonjsModule(function (module) {
  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }

  module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  });

  var _toConsumableArray = unwrapExports(toConsumableArray);

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  var _id = 1;
  /**
   * Provides a ToastContext for `useToast` and `useTask` hooks
   * 
   * @see useToast
   * @see useTask
   */

  var ToastProvider = /*#__PURE__*/function (_React$Component) {
    _inherits(ToastProvider, _React$Component);

    var _super = _createSuper$1(ToastProvider);

    function ToastProvider(_props2) {
      var _this;

      _classCallCheck(this, ToastProvider);

      _this = _super.call(this, _props2);

      _defineProperty(_assertThisInitialized(_this), "addToast", function (_props) {
        var toast_id = ToastProvider.nextId();
        /**@type {import("./context").AddToastProps} */

        var props = typeof _props === "string" ? {
          message: _props,
          severity: "info"
        } : _props;
        var timeout = typeof props.timeout === "number" ? props.timeout : _this.props.timeout;

        if (0 < timeout) {
          setTimeout(function () {
            _this.removeToast(toast_id);
          }, timeout);
        }

        _this.setState(function (state) {
          return {
            toasts: [].concat(_toConsumableArray(state.toasts), [_objectSpread$1({
              id: toast_id,
              onDismiss: _this.removeToast.bind(_assertThisInitialized(_this), toast_id)
            }, props)])
          };
        });

        return toast_id;
      });

      _defineProperty(_assertThisInitialized(_this), "removeToast", function (id) {
        _this.setState(function (state) {
          return {
            toasts: state.toasts.filter(function (t) {
              return t.id !== id;
            })
          };
        });
      });

      _this.state = {
        toasts: [],
        tasks: []
      };
      return _this;
    }

    _createClass(ToastProvider, [{
      key: "render",
      value: function render() {
        var tasks = this.state.toasts.filter(function (t) {
          return t.severity === "task";
        });
        var toasts = this.state.toasts.filter(function (t) {
          return t.severity !== "task";
        });
        return /*#__PURE__*/React__default["default"].createElement(ToastContext.Provider, {
          value: {
            addToast: this.addToast,
            removeToast: this.removeToast
          }
        }, /*#__PURE__*/React__default["default"].createElement(TaskContainer, {
          tasks: tasks
        }), /*#__PURE__*/React__default["default"].createElement(ToastContainer, {
          toasts: toasts,
          capacity: this.props.capacity
        }), this.props.children);
      }
    }], [{
      key: "nextId",
      value:
      /**
       * monotonically increasing id generator
       * @returns {number}
       */
      function nextId() {
        return _id++;
      }
      /**
       * adds a toast. it can accept any custom parameter that would get picked-up by a consummer later-on.
       * @method
       * @param {import("./context").AddToastProps|string} _props - the toast's properties or a message string for a simple toast
       * @returns {import("./context").ToastId} - the created toast's ID
       * @see Toast
       */

    }]);

    return ToastProvider;
  }(React__default["default"].Component);

  _defineProperty(ToastProvider, "propTypes", {
    timeout: PropTypes__default["default"].number.isRequired,
    capacity: PropTypes__default["default"].number.isRequired,
    children: PropTypes__default["default"].node
  });

  _defineProperty(ToastProvider, "defaultProps", {
    timeout: 3000,
    capacity: 5
  });

  var _excluded = ["type", "onDismiss", "onConfirm"];

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  var ModalProvider = /*#__PURE__*/function (_React$Component) {
    _inherits(ModalProvider, _React$Component);

    var _super = _createSuper(ModalProvider);

    function ModalProvider(props) {
      var _this;

      _classCallCheck(this, ModalProvider);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "handleDismiss", function (cb) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        if (typeof cb === "function") cb.apply(void 0, args); //eslint-disable-line callback-return

        _this.setState(function (_ref) {
          var pendingModals = _ref.pendingModals;
          return {
            pendingModals: pendingModals.slice(1)
          };
        });
      });

      _defineProperty(_assertThisInitialized(_this), "addModal", function (modal) {
        var id = ++ModalProvider.id_count;

        _this.setState(function (_ref2) {
          var pendingModals = _ref2.pendingModals;
          return {
            pendingModals: pendingModals.concat([_objectSpread({
              id: id
            }, modal)])
          };
        });

        return id;
      });

      _defineProperty(_assertThisInitialized(_this), "removeModal", function (id) {
        _this.setState(function (_ref3) {
          var pendingModals = _ref3.pendingModals;
          return {
            pendingModals: pendingModals.filter(function (m) {
              return m.id !== id;
            })
          };
        });
      });

      _this.state = {
        pendingModals: []
      };
      return _this;
    }

    _createClass(ModalProvider, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var modal = null;
        var nextModal = this.state.pendingModals[0];

        if (nextModal) {
          var _nextModal$type = nextModal.type,
              Container = _nextModal$type === void 0 ? StackModal : _nextModal$type,
              _onDismiss = nextModal.onDismiss,
              _onConfirm = nextModal.onConfirm,
              modalProps = _objectWithoutProperties(nextModal, _excluded);

          modal = /*#__PURE__*/React__default["default"].createElement(Container, _extends$z({}, modalProps, {
            "data-modaltype": Container.name,
            onDismiss: function onDismiss() {
              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              return _this2.handleDismiss.apply(_this2, [_onDismiss].concat(args));
            },
            onConfirm: function onConfirm() {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }

              return _this2.handleDismiss.apply(_this2, [_onConfirm].concat(args));
            }
          }));
        }

        return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, modal, /*#__PURE__*/React__default["default"].createElement(ModalContext.Provider, {
          value: {
            addModal: this.addModal,
            removeModal: this.removeModal
          }
        }, this.props.children));
      }
    }]);

    return ModalProvider;
  }(React__default["default"].Component);

  _defineProperty(ModalProvider, "id_count", 0);
  ModalProvider.propTypes = {
    children: PropTypes__default["default"].node
  };

  exports.BaseDefaultProps = BaseDefaultProps;
  exports.BasePropTypes = BasePropTypes;
  exports.Checkbox = Checkbox;
  exports.ConfirmModal = ConfirmModal;
  exports.ErrorBoundary = ErrorBoundary;
  exports.ErrorMessage = ErrorMessage;
  exports.FakeEvent = FakeEvent;
  exports.FlatList = FlatList;
  exports.FlatMap = FlatMap;
  exports.Icon = Icon;
  exports.Infotip = Infotip;
  exports.ItemShape = ItemShape;
  exports.ListItem = ListItem;
  exports.Loader = Loader;
  exports.MapItem = MapItem;
  exports.Modal = Modal;
  exports.ModalProvider = ModalProvider;
  exports.NewListItem = NewListItem;
  exports.NewMapItem = NewMapItem;
  exports.Selector = Selector;
  exports.SelectorPropTypes = SelectorPropTypes;
  exports.StackModal = StackModal;
  exports.Switch = Switch;
  exports.TaskContainer = TaskContainer;
  exports.TextInputModal = TextInputModal;
  exports.Toast = Toast;
  exports.ToastContainer = ToastContainer;
  exports.ToastIcon = ToastIcon;
  exports.ToastProvider = ToastProvider;
  exports.Tooltip = Tooltip;
  exports.contexts = context;
  exports.icons = index;
  exports.logLevels = logLevels;
  exports.uid = uid;
  exports.useModal = useModal;
  exports.useTask = useTask;
  exports.useToast = useToast;
  exports.withState = withState;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
